import React from 'react'
import { Link } from 'react-router-dom'
import FavouriteItems from './FavouriteItems'
import FavouriteRestaurent from './FavouriteRestaurent'
import MobileBottomBar from '../Layout/MobileBottomBar'

const Favourite = () => {

    return (
        <>
            <section className="bredcump-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link href="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Favorites
                                    </li>
                                </ol>
                            </nav>
                            <h3 className="title">Favorites</h3>

                        </div>
                    </div>
                </div>
            </section>
            <section className="favorites-sec tp-space pb-5 pt-0">
                <div className="container">
                    <div className="custom-tabs">
                        <ul className="nav" id="myTab" role="tablist">
                            <li className="tab-item" role="presentation">
                                <button className="tab-link active" data-bs-toggle="tab" data-bs-target="#tab-01" type="button" role="tab">
                                    Restaurant
                                </button>
                            </li>
                            <li className="tab-item" role="presentation">
                                <button className="tab-link" data-bs-toggle="tab" data-bs-target="#tab-02" type="button" role="tab">
                                    Items
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="tab-01" role="tabpanel" tabIndex={0} >
                                <div className="row">
                                    <FavouriteRestaurent />
                                </div>
                            </div>
                            <div className="tab-pane fade" id="tab-02" role="tabpanel" tabIndex={0} >
                                <div className="row">
                                    <FavouriteItems />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default Favourite
